<template>
    <div>
        <div class="hero _fixed bg-secondary">
            <div class="hero-content text-center">
                <h1 class="text-white">{{ $t('Booking') }}</h1>
            </div>
        </div>

        <div class="section">
            <div class="container">
                <form action="/api/booking.php" method="post">
                    <div class="flex flex-wrap md:-mx-base lg:-mx-gap">
                        <div class="form-group w-full md:w-1/2 mb-base md:mb-lg md:px-base lg:px-gap">
                            <label for="title">{{ $t('Title') }}</label>
                            <input type="text" id="title" name="title" v-model="form.title" class="form-control">
                        </div>

                        <div class="form-group w-full md:w-1/2 mb-base md:mb-lg md:px-base lg:px-gap">
                            <label for="name">{{ $t('Fullname') }}</label>
                            <input type="text" id="name" name="name" v-model="form.name" class="form-control">
                        </div>

                        <div class="form-group w-full md:w-1/2 mb-base md:mb-lg md:px-base lg:px-gap">
                            <label for="address">{{ $t('Address') }}</label>
                            <input type="text" id="address" name="address" v-model="form.address" class="form-control">
                        </div>

                        <div class="form-group w-full md:w-1/2 mb-base md:mb-lg md:px-base lg:px-gap">
                            <label for="zip">{{ $t('ZIP Code') }}</label>
                            <input type="text" id="zip" name="zip" v-model="form.zip" class="form-control">
                        </div>

                        <div class="form-group w-full md:w-1/2 mb-base md:mb-lg md:px-base lg:px-gap">
                            <label for="city">{{ $t('City') }}</label>
                            <input type="text" id="city" name="city" v-model="form.city" class="form-control">
                        </div>

                        <div class="form-group w-full md:w-1/2 mb-base md:mb-lg md:px-base lg:px-gap">
                            <label for="country">{{ $t('Country') }}</label>
                            <input type="text" id="country" name="country" v-model="form.country" class="form-control">
                        </div>

                        <div class="form-group w-full md:w-1/2 mb-base md:mb-lg md:px-base lg:px-gap">
                            <label for="phone">{{ $t('Phone') }}</label>
                            <input type="text" id="phone" name="phone" v-model="form.phone" class="form-control">
                        </div>

                        <div class="form-group w-full md:w-1/2 mb-base md:mb-lg md:px-base lg:px-gap">
                            <label for="email">{{ $t('Email') }}</label>
                            <input type="text" id="email" name="email" v-model="form.email" class="form-control">
                        </div>

                        <div class="w-full md:w-1/2 mb-base md:mb-lg md:px-base lg:px-gap">
                            <div class="flex flex-wrap -mx-base">
                                <div class="form-group w-1/2 px-base">
                                    <label for="date-from">{{ $t('From') }}</label>
                                    <datepicker :inline="false" v-model="form.from" :format="state.format" id="date-from" input-class="form-control" :disabledDates="state.disabledDates" :highlighted="unavailableDates" :minimumView="'day'" :maximumView="'day'" placeholder="" @closed="calculateDateRange('from')"></datepicker>
                                </div>
                                <div class="form-group w-1/2 px-base">
                                    <label for="date-to">{{ $t('To') }}</label>
                                    <datepicker :inline="false" v-model="form.to" :format="state.format" id="date-to" input-class="form-control" :disabledDates="state.disabledDates" :highlighted="unavailableDates" :minimumView="'day'" :maximumView="'day'" placeholder="" @closed="calculateDateRange('to')"></datepicker>
                                </div>
                            </div>
                        </div>

                        <div class="w-full md:w-1/2 mb-base md:mb-lg md:px-base lg:px-gap">
                            <div class="flex flex-wrap -mx-base">
                                <div class="form-group w-1/2 px-base">
                                    <label for="adults">{{ $t('Adults') }}</label>
                                    <input type="number" id="adults" name="adults" v-model.number="form.adults" class="form-control" min="1" :max="availableAdults">
                                </div>
                                <div class="form-group w-1/2 px-base">
                                    <label for="children">{{ $t('Children') }}</label>
                                    <input type="number" id="children" name="children" v-model.number="form.children" class="form-control" min="0" :max="availableChildren">
                                </div>
                            </div>
                        </div>

                        <div class="form-group w-full md:px-base lg:px-gap">
                            <label for="message">{{ $t('Message') }}</label>
                            <textarea id="message" name="message" v-model="form.message" class="form-control" rows="4"></textarea>
                        </div>
                    </div>

                    <div class="submit-box flex flex-wrap lg:items-center mt-lg md:mt-gap">
                        <div class="flex justify-center lg:justify-end w-full lg:w-1/2">
                            <button type="button" class="btn" @click="submit" :class="{ 'is-processing': isProcessing }" :disabled="isProcessing">{{ $t('btn.book-send') }}</button>
                        </div>
                        
                        <div class="w-full lg:w-1/2 text-center lg:text-left mt-2 lg:mt-0">
                            <input type="checkbox" id="terms" name="terms" v-model="form.terms">
                            <label for="terms">{{ $t('booking.terms-text') }} <router-link :to="{ name: 'terms', params: { locale: $i18n.locale() } }" target="_blank" class="text-body active:text-secondary focus:text-secondary hover:text-secondary trans-color" exact>{{ $t('booking.terms-link-text') }}</router-link></label>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="alert _dock" :class="response.status" v-html="response.message" v-if="response.status && response.message" @click="resetResponse"></div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'

export default {
    components: {
        Datepicker
    },

    data() {
        return {
            isProcessing: false,
            response: {
                status: null,
                message: null
            },
            format: 'YYYY-MM-DD',
            unavailableDates: {
                dates: this.parseUnavailableDates()
            },
            state: {
                format: 'yyyy-MM-dd',
                disabledDates: {
                    to: new Date()
                }
            },
            form: {
                title: '',
                name: '',
                address: '',
                zip: '',
                city: '',
                country: '',
                phone: '',
                email: '',
                message: '',
                from: null,
                to: null,
                adults: 2,
                children: 0,
                terms: false
            },
            maxPersons: 9
        }
    },

    computed: {
        availableAdults() {
            return 9 - this.form.children
        },
        availableChildren() {
            return 9 - this.form.adults
        }
    },

    methods: {
        parseUnavailableDates() {
            let data = []

            this.$root.Config.googleCalendar.forEach(function (value) {

                let date = moment(value, 'D-M-YYYY')

                if (date.isValid()) {
                    data.push(date.toDate())
                }
            })

            return data
        },

        calculateDateRange(type) {
            let from = this.form.from ? moment(this.form.from, this.format) : moment(),
                to = this.form.to ? moment(this.form.to, this.format) : from

            if (from.isValid()) {
                if (to.isValid() && from >= to) {
                    if (type === 'from') {
                        this.form.to = from.add(7, 'day').format(this.format)
                    } else {
                        this.form.from = to.subtract(7, 'day').format(this.format)
                    }
                } else {
                    this.form.to = from.add(7, 'day').format(this.format)
                }
            }
        },

        submit(event) {
            let action = event.target.closest('form').getAttribute('action')

            this.isProcessing = true
            this.resetResponse()

            axios.post(action, this.form)
                .then(response => {
                    this.response.status = 'success'
                    this.response.message = this.$t(response.data)

                    this.isProcessing = false
                    this.resetForm();
                })
                .catch(error => {
                    this.response.status = 'danger'
                    this.response.message = this.$t(error.response.data)

                    this.isProcessing = false
                })
        },

        resetResponse() {
            this.response.status = null
            this.response.message = null
        },

        resetForm() {
            this.form = {
                title: '',
                name: '',
                address: '',
                zip: '',
                city: '',
                country: '',
                phone: '',
                email: '',
                message: '',
                from: null,
                to: null,
                adults: 2,
                children: 0,
                terms: false
            }
        }
    }
}
</script>
